import type { InterruptionFilter } from './interruption';

export enum ECancelChartTypes {
  CURRENCY = 'currency',
  PERCENTAGE = 'percentage',
}

export interface ICancelFilter extends InterruptionFilter {
  canceled_at_initial?: string;
  canceled_at_final?: string;
}

export interface ICancelChart {
  subscriptions_total: number;
  subscriptions_amount: number;
  chart: Array<{
    total: number;
    reason: string;
    amount: number;
    percentage: number;
  }>;
}
